export const getCurrentWeekObj = weeks => weeks[1]

export const getCurrentWeek = weeks => {
    const weekObj = getCurrentWeekObj(weeks)

    return weekObj.isoWeek
}

export default getCurrentWeek